import"../../utils/index.js";import{formatFileSize as t}from"../../utils/formatFileSize.js";var o=function(o,i){return o>=0&&i>=0?"".concat(t(i)," of ").concat(t(o)):null};export{o as formatSizeProgress};
